import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { isValidElement } from 'react';
import StickyNode from '../../../molecules/StickyNode';
import capitalizeFirstLetter from '../../../utils/capitalizeFirstLetter';
import constant from '../../../utils/constant';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
import Icon from '../../Icon';
import Cross from '../../SvgIcon/Icons/Cross';
const COMPONENT_NAME = 'Popover';
const getIconElement = (icon)=>{
    if (/*#__PURE__*/ isValidElement(icon)) {
        return icon;
    } else if (icon) {
        return /*#__PURE__*/ React.createElement(Icon, {
            name: icon
        });
    }
};
const Popover = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { className, children, type, icon, onClose, closeable, floating, stickyNodeProps } = props;
    const iconElement = getIconElement(icon);
    const popover = /*#__PURE__*/ React.createElement("div", {
        className: cx('Popover', type && `Popover--type${capitalizeFirstLetter(type)}`, className)
    }, iconElement ? /*#__PURE__*/ React.createElement("div", {
        className: "Popover-icon"
    }, iconElement) : null, /*#__PURE__*/ React.createElement("div", {
        className: "Popover-content"
    }, children), closeable ? /*#__PURE__*/ React.createElement("div", {
        className: "Popover-close",
        onClick: onClose
    }, /*#__PURE__*/ React.createElement(Cross, null)) : null);
    return floating ? /*#__PURE__*/ React.createElement(StickyNode, {
        enabled: true,
        ...stickyNodeProps
    }, popover) : popover;
};
export const types = constant({
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
    SUCCESS: 'success'
});
Popover.propTypes = {
    /**
	 * Text (body) of the popover
	 */ children: PropTypes.node.isRequired,
    /**
	 * Component classname
	 */ className: PropTypes.string,
    /**
	 * Whether popover is closable. if true close button will be added.
	 * Actual close functionality must be implemented using `onClose` callback and `open` property
	 */ closeable: PropTypes.bool,
    /**
	 * Whether popover is floating- sticky or not
	 */ floating: PropTypes.bool,
    /**
	 * Icon used inside the popover. Can be string or Icon element
	 */ icon: PropTypes.node,
    /**
	 * Callback when close icon is clicked
	 *
	 * @param {object} event event targeting the element.
	 * @return {undefined} Nothing
	 */ onClose: PropTypes.func,
    /**
	 * Props to be passed to underlying StickyNode Component when `floating` is truthy
	 */ stickyNodeProps: PropTypes.object,
    /**
	 * Either 'error' or 'warning'
	 */ type: PropTypes.oneOf(types.values())
};
Popover.types = types;
export default Popover;
